import { render, staticRenderFns } from "./PremiumMarket.vue?vue&type=template&id=71ff2f71&scoped=true"
import script from "./PremiumMarket.vue?vue&type=script&lang=js"
export * from "./PremiumMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff2f71",
  null
  
)

export default component.exports